export default __webpack_public_path__ + "static/media/image2Vector.b9ec1854.svg";